import { render } from "./InstitutionHeader.vue?vue&type=template&id=b52309d8&lang=pug"
import script from "./InstitutionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__